var map = {
  "./cs.messages.tsx": [
    "77955",
    [
      1019
    ]
  ],
  "./en.messages.tsx": [
    "98110",
    [
      4976
    ]
  ],
  "./sl.messages.tsx": [
    "49450",
    [
      5744
    ]
  ],
  "./hu.messages.tsx": [
    "49650",
    [
      6520
    ]
  ],
  "./de.messages.tsx": [
    "16614",
    [
      1980
    ]
  ],
  "./it.messages.tsx": [
    "57428",
    [
      2226
    ]
  ],
  "./pl.messages.tsx": [
    "49501",
    [
      8001
    ]
  ],
  "./sk.messages.tsx": [
    "50763",
    [
      8515
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 98861;
module.exports = __rspack_async_context;
